module.exports = __webpack_public_path__ + "static/media/calendar.1aa6c058.webp";